import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_PersonAbsences_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_PersonAbsences_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'absences' = 'absences',
}

export enum Config_PersonAbsences_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_PersonAbsences_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_PersonAbsences_ApiInterface
    extends ConfigDataInterface<
        Config_PersonAbsences_Modules_ApiEnum,
        Config_PersonAbsences_ActionsMenu_ApiEnum,
        Config_PersonAbsences_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_PersonAbsences_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
